import { RecordingSetupSelection } from "@/hooks/useRecordingSetupSelection";
import { MicrophoneStatus } from "@/types/microphoneStatus";
import { RecordingData } from "@/utils/indexedDBUtils";
import { createContext } from "use-context-selector";

export interface PrepareRecordingContextType extends RecordingSetupSelection {
  selectedAudioType: string;
  setSelectedAudioType: React.Dispatch<React.SetStateAction<string>>;
  isAudioActive: boolean;
  onMicrophoneStatusChange: (status: MicrophoneStatus) => void;
  createNewRecordingHandler: () => Promise<RecordingData>;
}

export const PrepareRecordingContext = createContext<PrepareRecordingContextType | undefined>(undefined);
